<div
    class="input-wrapper"
    [placement]="inputTooltipPlacement"
    [tcTooltip]="inputTooltipText"
    [ngClass]="{ error: !isValid, disabled: inputIsDisabled, isSmall: inputIsSmall }"
>
    <input
        id="{{ _id }}"
        type="number"
        [(ngModel)]="value"
        name="{{ inputName }}"
        (blur)="onBlur()"
        autocomplete="off"
        [disabled]="inputIsDisabled"
        pattern="{{ regex }}"
        step="1"
        min="{{ inputMinValue }}"
        max="{{ inputMaxValue }}"
        placeholder="{{ inputIsRequired ? inputName + '*' : inputName }}"
        [ngClass]="{ isSmall: inputIsSmall, isEmpty: !_innerValue && _innerValue !== 0 }"
    />
    <label
        [tcTooltip]="inputName"
        [onlyEllipsisTooltip]="true"
        tabindex="-1"
        *ngIf="_innerValue || _innerValue === 0"
        htmlFor="{{ _id }}"
        >{{ inputName }}
        <span *ngIf="inputIsRequired">*</span>
    </label>
</div>
